<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form>
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">{{ title }}</span>
          </v-card-title>
          <v-card-text style="text-align: center;">
            <v-container grid-list-md>
              <v-layout wrap>
                    <p style="font-size: 18px;">{{ text }}</p>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-text style="text-align: center;" v-show="!cond">
            
          </v-card-text>

          <v-card-text style="text-align: center;" v-show="cond">
            <v-btn round color="gradiente" style="background: #EF5350; " class="white--text but" @click="cancel" >Cancelar</v-btn>
            <v-btn round color="gradiente" style="background: #EF5350; " class="white--text but" @click="continuar" >Continuar</v-btn>
          </v-card-text>

        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components:{
  },
  props: ["value", "text", "title", "cond"],
  data: () => ({

  }),
  methods: {
    cancel() {
      this.$emit("cancelled");
    },
    continuar() {
      this.$emit("continue");
    }
  },
  computed: {
    
  },
  mounted() {
      
  },
};
</script>

<style>
.but{
  background: #EF5350; 
  height: 37px; 
  width: 150px;
}
</style>
